module.exports = __webpack_public_path__ + "static/video-credit-counseling-d061b683237b5134b501c978fa64fae8.png";